import { render, staticRenderFns } from "./RightToWorkDetails.vue?vue&type=template&id=5d23178a&scoped=true&"
import script from "./RightToWorkDetails.vue?vue&type=script&lang=js&"
export * from "./RightToWorkDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d23178a",
  null
  
)

export default component.exports